import * as React from "react";
const SvgArrowBackIosNewOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M17.77 3.77 16 2 6 12l10 10 1.77-1.77L9.54 12z" />
  </svg>
);
export default SvgArrowBackIosNewOutlined;
